import ptBR from "../locales/pt-BR";
import enUS from "../locales/en-US";
import esES from "../locales/es-ES";
import deDE from "../locales/de-DE";

const LANGUAGES = {
  "pt-BR": ptBR,
  "en-US": enUS,
  "es-ES": esES,
  "de-DE": deDE,
};

let currentLanguage = "pt-BR";

const formatMessage = (slug, language) => {
  const lang = language || currentLanguage;
  return LANGUAGES?.[lang]?.[slug] || LANGUAGES?.["pt-BR"]?.[slug] || slug;
};

const setLanguage = (language) => {
  if (LANGUAGES[language]) {
    currentLanguage = language;
  }
};

const getLanguage = () => currentLanguage;

const sanitize = (text) => {
  return (text || "")
    .replace(/\//gi, "")
    .replace(/ /gi, "")
    .replace(/\./gi, "")
    .replace(/-/gi, "")
    .replace(/_/gi, "")
    .replace(/\(/gi, "")
    .replace(/\)/gi, "");
};

const sanitizeRG = (text) => {
  return (text || "")
    .replace(/ /gi, "")
    .replace(/\./gi, "")
    .replace(/-/gi, "")
    .replace(/_/gi, "")
    .replace(/\(/gi, "")
    .replace(/\)/gi, "");
};

export {
  LANGUAGES,
  formatMessage,
  setLanguage,
  getLanguage,
  sanitize,
  sanitizeRG,
};
